import React, { useEffect, useState } from "react";
import { Topbar } from "@components";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TOPUP_LK, CREATE_MODE_LK, PAY_SK, BANK_SK } from "@constants";
import {
  Item,
  RootContainer,
  Title,
  Text,
  Image,
  SpinWrapper,
} from "./ChooseAccountType.style";
import { Col, Row, Spin } from "antd";
import { PRIVATE_ROUTE } from "@router/route.constants";
import { api } from "@api";
import { useTranslation } from "react-i18next";

const ChooseAccountType = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { trx_type } = useParams();
  const { state } = useLocation();
  const [loading, setLoading] = useState(true);
  const [pays, setPays] = useState([]);
  const [banks, setBanks] = useState([]);

  const title =
    trx_type === TOPUP_LK
      ? t("wallet.walletTopUp")
      : t("wallet.walletWithdraw");
  const labelPay =
    trx_type === TOPUP_LK ? t("wallet.topUpFromPay") : t("wallet.choosePay");

  const labelBankAccount =
    trx_type === TOPUP_LK
      ? t("wallet.topUpFromBankAccount")
      : t("wallet.chooseBankAccount");

  useEffect(() => {
    getPaymentCategories();

    // eslint-disable-next-line
  }, []);

  const getPaymentCategories = () => {
    setLoading(true);
    if (trx_type === TOPUP_LK) {
      api
        .getPaymentCategories()
        .then(({ payment_categories }) => {
          setLoading(false);
          setPays(payment_categories.filter((item) => item.type === PAY_SK));
          setBanks(payment_categories.filter((item) => item.type === BANK_SK));
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      api
        .getUserPaymentCategories()
        .then(({ payment_categories }) => {
          setLoading(false);
          setPays(payment_categories.filter((item) => item.type === PAY_SK));
          setBanks(payment_categories.filter((item) => item.type === BANK_SK));
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  const handleItemClicked = (item) => {
    if (trx_type === TOPUP_LK) {
      navigate(`/${PRIVATE_ROUTE.FILL_AMOUNT}/${trx_type}`, {
        state: item,
      });
    } else {
      navigate(`/${PRIVATE_ROUTE.CREATE_UPDATE_ACCOUNT}/${state?.mode || CREATE_MODE_LK}`, {
        replace: true,
        state: {
          payment: item,
          item: state?.item,
        },
      });
    }
  };

  const goBack = () => {
    if (trx_type === TOPUP_LK) {
      navigate(`/${PRIVATE_ROUTE.WALLET}`);
    } else {
      navigate(state ? -1 : `/${PRIVATE_ROUTE.WITHDRAW_ACCOUNTS}`);
    }
  };

  const Loader = () => (
    <SpinWrapper>
      <Spin />
    </SpinWrapper>
  );

  return (
    <>
      <Topbar title={title} goBack={goBack} />
      {loading && <Loader />}
      {!loading && (
        <RootContainer>
          {pays.length > 0 && <Title>{labelPay}</Title>}
          <Row gutter={[16, 16]}>
            {pays.map((item, key) => (
              <Col xs={6} key={key}>
                <Item onClick={() => handleItemClicked(item)}>
                  <Image src={item.image} />
                  <Text>{item.name}</Text>
                </Item>
              </Col>
            ))}
          </Row>
          {banks.length > 0 && <Title>{labelBankAccount}</Title>}
          <Row gutter={[16, 16]}>
            {banks.map((item, key) => (
              <Col xs={6} key={key}>
                <Item onClick={() => handleItemClicked(item)}>
                  <Image src={item.image} />
                  <Text>{item.name}</Text>
                </Item>
              </Col>
            ))}
          </Row>
        </RootContainer>
      )}
    </>
  );
};

export default ChooseAccountType;
